import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import App from "../App";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { pages } from "../utils/common";
import LoginViewRoot from "./modules/login";
import ProtectedRoute from "../components/ProtectedRoute";
import useDashboardRoutes from "./modules/dashboard/useDashboard.routes";
import useInstituteRoutes from "./modules/institute/useInstitute.routes";
import useSpocPremiseRoutes from "./modules/spocPremise/useSpocPremise.routes";
import useComplianceRoutes from "./modules/compliance/useCompliance.routes";
import useAcademicRoutes from "./modules/academic/useAcademic.routes";
import useAcademicsRoutes from "./modules/academics/useAcademics.routes";
import useLessonPlanRoutes from "./modules/lessonPlan/useLessonPlan.routes";
import useMaterialRoutes from "./modules/material/useMaterial.routes";
import useObepRoutes from "./modules/obep/useObep.routes";
import useAssessmentRoutes from "./modules/assessment/useAssessment.routes";
import useBrandingRoutes from "./modules/branding/useBranding.routes";
import useLocalizationRoutes from "./modules/localization/useLocalization.routes";
import useRbacRoutes from "./modules/rbac/useRbac.routes";
import useAuditTrailRoutes from "./modules/auditTrail/useAuditTrail.routes";
import useHelpRoutes from "./modules/help/useHelp.routes";
import useUsersAdminRoutes from "./modules/users/useUsersAdmin.routes";

const AllRoutes = () => {
  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      data-testid="localization-provider"
    >
      <BrowserRouter basename={"/"} data-testid="browser-router">
        <Routes data-testid="app-routes">
          <Route path={pages.auth.path} element={<App />}>
            <Route index element={<LoginViewRoot />} />
            <Route element={<ProtectedRoute />}>
              {useDashboardRoutes()}
              {useInstituteRoutes()}
              {useSpocPremiseRoutes()}
              {useComplianceRoutes()}
              <Route
                path={`${pages.feeStructure.path}/*`}
                element={
                  <Navigate to={`${pages.academics.path}/classes`} replace />
                }
              />
              {useAcademicsRoutes()}
              {useAcademicRoutes()}
              {useLessonPlanRoutes()}
              {useMaterialRoutes()}
              {useObepRoutes()}
              {useAssessmentRoutes()}
              {useBrandingRoutes()}
              {useLocalizationRoutes()}
              {useRbacRoutes()}
              {useAuditTrailRoutes()}
              {useHelpRoutes()}
              {useUsersAdminRoutes()}
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </LocalizationProvider>
  );
};
export default AllRoutes;
